import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-loading-banner',
  templateUrl: './loading-banner.component.html',
  styleUrls: ['./loading-banner.component.scss'],
})
export class LoadingBannerComponent {}
